// extracted by mini-css-extract-plugin
module.exports = {"component":"SwitchSetting_component__3rG8o","title":"SwitchSetting_title__3zs7Z"};